import React from "react";
import { usePayment } from "../contexts/PaymentContext";
import styles from "./UpgradeModal.module.css";

const PLANS = [
  {
    id: "credits",
    name: "Starter Pack",
    price: 50,
    label: "₹50",
    period: "one-time",
    features: ["50 AI-generated messages", "Priority templates", "No expiry"],
    accent: "blue",
  },
  {
    id: "unlimited",
    name: "Unlimited Pro",
    price: 99,
    label: "₹99",
    period: "/month",
    features: [
      "Unlimited AI messages",
      "Follow-up generation",
      "Priority support",
    ],
    accent: "purple",
    popular: true,
  },
];

export default function UpgradeModal() {
  const {
    showUpgradeModal,
    upgradeData,
    paymentProcessing,
    paymentResult,
    handlePayment,
    dismissUpgrade,
  } = usePayment();

  if (!showUpgradeModal) return null;

  // Determine context-aware header
  const defaultMsg = "You've used all your free AI messages for today";
  const headerMsg = upgradeData?.message || defaultMsg;

  return (
    <div className={styles.overlay} onClick={dismissUpgrade}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Upgrade your plan"
      >
        <button
          className={styles.closeBtn}
          onClick={dismissUpgrade}
          aria-label="Close"
        >
          ×
        </button>

        {/* Header */}
        <div className={styles.header}>
          <span className={styles.headerIcon}>🚀</span>
          <h2 className={styles.title}>{headerMsg}</h2>
          <p className={styles.subtitle}>
            Upgrade to keep generating AI-powered referral messages
          </p>
          <p className={styles.freeTip}>
            Free users get <strong>5 AI messages/day</strong>. Want more? Pick a plan below.
          </p>
        </div>

        {/* Plan cards */}
        <div className={styles.plans}>
          {PLANS.map((plan) => (
            <div
              key={plan.id}
              className={`${styles.planCard} ${
                plan.popular ? styles.planPopular : ""
              }`}
            >
              {plan.popular && (
                <span className={styles.popularBadge}>Most Popular</span>
              )}
              <h3 className={styles.planName}>{plan.name}</h3>
              <div className={styles.planPrice}>
                <span className={styles.priceAmount}>{plan.label}</span>
                <span className={styles.pricePeriod}>{plan.period}</span>
              </div>
              <ul className={styles.planFeatures}>
                {plan.features.map((f, i) => (
                  <li key={i}>
                    <span className={styles.checkIcon}>✓</span> {f}
                  </li>
                ))}
              </ul>
              <button
                className={`${styles.planBtn} ${
                  plan.popular ? styles.planBtnPrimary : styles.planBtnOutline
                }`}
                onClick={() => handlePayment(plan.id)}
                disabled={paymentProcessing}
              >
                {paymentProcessing ? "Processing…" : `Choose ${plan.name}`}
              </button>
            </div>
          ))}
        </div>

        {/* Payment result feedback */}
        {paymentResult && (
          <div
            className={`${styles.resultBanner} ${
              paymentResult.success ? styles.resultSuccess : styles.resultError
            }`}
          >
            <span>{paymentResult.success ? "✅" : "⚠️"}</span>
            <span>{paymentResult.message}</span>
            {paymentResult.success && (
              <button className={styles.resultDone} onClick={dismissUpgrade}>
                Continue
              </button>
            )}
          </div>
        )}

        <p className={styles.secureLine}>
          🔒 Payments secured by Razorpay. Cancel anytime.
        </p>
      </div>
    </div>
  );
}
